import React, { useState, useRef, useEffect } from "react";
import Avatar from "../../components/Common/Avatar";
import Button from "../../components/Buttons/Button";
import { dateFormator } from "../../utils";
import DropdownMenu from "../Buttons/DropdownMenu";

const Chat = ({ key, data, sender, loginUserId }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    // Add event listener when dropdown is open
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  // Toggle dropdown when menu button is clicked
  const handleMenuClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div
      id={key}
      className={`flex ${loginUserId === sender.id ? "justify-end" : ""}`}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => {
        // Only hide the menu button when hovering out if dropdown is not open
        if (!isDropdownOpen) {
          setIsHovering(false);
        }
      }}
    >
      <div className="w-full max-w-xl flex flex-col gap-3 my-5">
        <div
          className={`flex justify-between items-center ${
            loginUserId === sender.id ? "flex-row-reverse" : ""
          }`}
        >
          <div
            className={`flex items-center gap-2 ${
              loginUserId === sender.id ? "flex-row-reverse" : ""
            }`}
          >
            <Avatar size="sm" alt={sender.name} src={sender.profilePhotoUrl} />
            <div className="font-semibold">{sender.name}</div>
            <div className="text-xs text-gray-400">
              {dateFormator(data.timestamp, "time-ampm")}
            </div>
          </div>

          {(isHovering || isDropdownOpen) && (
            <div ref={dropdownRef}>
              <DropdownMenu
                //menuAlign={loginUserId === sender.id ? "left" : "right"}

                MenuSection={
                  <div className="flex flex-col">
                    <Button
                      title={"Option 1"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-1"
                    />
                    <Button
                      title={"Option 2"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-1"
                    />
                  </div>
                }
                isOpen={isDropdownOpen}
                onToggle={handleMenuClick}
              >
                <Button
                  type="icon"
                  variant="text"
                  icon={"menu"}
                  color="black"
                  size="xs"
                  onClick={handleMenuClick}
                />
              </DropdownMenu>
            </div>
          )}
        </div>
        <div className="border-[1px] border-gray-200 p-3 rounded-md">
          {data.message}
        </div>
      </div>
    </div>
  );
};

export default Chat;
